import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { TrendingUp } from "lucide-react";

export function PerformanceList({ data }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-primary" />
          This Week's Performance
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {data?.weeklyPerformance?.map((day, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-4 rounded-lg bg-muted/30"
            >
              <div className="font-medium text-foreground">{day.day}</div>
              <div className="grid grid-cols-4 gap-6 text-sm">
                <div className="text-center">
                  <div className="text-muted-foreground">Calls</div>
                  <div className="font-semibold text-foreground">{day.calls || 0}</div>
                </div>
                <div className="text-center">
                  <div className="text-muted-foreground">Payments</div>
                  <div className="font-semibold text-success">{day.payments || 0}</div>
                </div>
                <div className="text-center">
                  <div className="text-muted-foreground">Services</div>
                  <div className="font-semibold text-foreground">{day.services || 0}</div>
                </div>
                <div className="text-center">
                  <div className="text-muted-foreground">Complaints</div>
                  <div className="font-semibold text-warning">{day.complaints || 0}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}